import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Reveal } from "@/components/Reveal";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "ArcView Homes respects your privacy. When you submit an enquiry through this website, we collect the details you provide — your name, phone number, email address, land ownership status, block location and project information — and use them for one purpose only: responding to your enquiry and discussing your project with you.",
      "We do not sell, rent or share your personal information with third parties for marketing purposes. Enquiries submitted through this website are sent to the ArcView Homes team at info@arcviewhomes.com.au.",
      "For any privacy question or request, contact us at info@arcviewhomes.com.au or call +61 432 402 555.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "The information on this website is general in nature and is provided for information purposes only. It does not constitute professional, legal, planning or financial advice.",
      "Project timeframes — including the stated handover timeframe of up to 6 months — are indicative only and are subject to project scope, approvals, site conditions and other project requirements. Nothing on this website should be read as a guarantee of a completion date, approval outcome or fixed price.",
      "Imagery shown on this website may include representative architectural imagery. To discuss your specific project, contact ArcView Homes at info@arcviewhomes.com.au or call +61 432 402 555.",
    ],
  },
};

export default function LegalPage({ kind }) {
  const c = CONTENT[kind];
  return (
    <div className="min-h-screen bg-cream text-charcoal flex flex-col">
      <header className="border-b border-line">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-8 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-logo-link" aria-label="Back to home">
            <Logo />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home-link"
            className="text-sm font-semibold border-b-2 border-arc pb-0.5 hover:text-arc transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </header>
      <main className="flex-1 max-w-3xl mx-auto w-full px-5 sm:px-8 py-16">
        <Reveal>
          <h1 className="font-serif text-4xl sm:text-5xl font-medium tracking-tight">{c.title}</h1>
          <div className="mt-8 space-y-5 text-mist leading-relaxed">
            {c.body.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </Reveal>
      </main>
      <footer className="border-t border-line py-6 text-center text-xs text-mist/70">
        © 2026 ArcView Homes. All rights reserved.
      </footer>
    </div>
  );
}
